export default __webpack_public_path__ + "static/media/shape-6.3094f64e.png";